"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var normalizePathname_1 = require("./normalizePathname");
/**
 * Adds location origin to a path to create a full URL
 *
 * @example
 *  addLocationOriginToUrl('/some/url/', 'https://www.zapier.ninja/')
 *  > 'https://www.zapier.ninja/some/url/'
 */
var addLocationOriginToUrl = function (url, origin) {
    // defaulting the argument would break imports on server-side
    if (typeof origin === 'undefined' && typeof window !== 'undefined') {
        origin = window.location.origin;
    }
    var httpProtocolMatch = url.match(/https?:\/\//);
    if (httpProtocolMatch && httpProtocolMatch.index === 0) {
        return url;
    }
    return "" + normalizePathname_1.stripTrailingSlash(origin) + url;
};
exports.default = addLocationOriginToUrl;
